var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"initial-text"},_vm._l(((_vm.initialText || '').split('|')),function(label){return _c('p',{domProps:{"innerHTML":_vm._s(label)}},[_vm._v(_vm._s(label)+"\t\t")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }